import { AutocompleteCandidates } from "@inputs/autocomplete/AutocompleteCandidates";
import { type Control, Controller, type UseFormSetValue } from "react-hook-form";
import type { IModalActionOptions } from "../index";
import type { IModalActionForm, IModalActionResolver, TModalAction } from "../logics/types";

export interface IModalActionFormCandidateProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
  action?: TModalAction;
  setValue: UseFormSetValue<IModalActionForm>;
  hidden?: boolean;
  options?: IModalActionOptions;
}

export const ModalActionFormCandidate = ({
  control,
  action,
  setValue,
  hidden = false,
  options,
}: IModalActionFormCandidateProps) => {
  if (hidden) {
    return null;
  }

  return (
    <Controller
      control={control}
      name="candidate"
      render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => (
        <AutocompleteCandidates
          value={value}
          handleChange={(value) => {
            onChange(value);
            setValue("jobFollowUp.apply", "");
          }}
          onBlur={onBlur}
          size="small"
          TextFieldProps={{ label: "Candidat *", inputRef: ref, error: Boolean(error), helperText: error?.message }}
          disabled={options?.disableCandidateField || Boolean(action?._id && action?.candidate)}
        />
      )}
    />
  );
};
